import { __assign } from "tslib";
import React from 'react';
import { Url } from '@wix/da-url';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
var MatureAnonymousBlockedOverlay = function (props) {
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ icon: React.createElement(Hidden, null), title: t('deviationview.blocked.mature.anon'), text: props.compact ? null : t('deviationview.blocked.mature.anon.text'), button: React.createElement(Button, { view: "b14", height: props.compact ? 'small' : 'medium', 
            // Keeping joinpoint=mature since it was specifically requested in the ticket
            href: Url.joinLink('mature'), biData: {
                evid: BiEventType.REDIRECT_TO_LOGIN,
                referral_info: ReferralType.MATURE,
            } }, t('deviationview.blocked.mature.anon.signIn')) }, props)));
};
MatureAnonymousBlockedOverlay.displayName = 'MatureAnonymousBlockedOverlay';
export default MatureAnonymousBlockedOverlay;
//# sourceMappingURL=MatureAnonymousBlocked.js.map